import { render } from "./input-range.vue?vue&type=template&id=284032ee&scoped=true"
import script from "./input-range.vue?vue&type=script&lang=js"
export * from "./input-range.vue?vue&type=script&lang=js"

import "./input-range.vue?vue&type=style&index=0&id=284032ee&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284032ee"]])

export default __exports__